import * as React from 'react';

import PropTypes from 'prop-types';

/*
 * Creates a rectangular-shaped View
 *
 * If provided children, they will be rendered in the center of the view,
 * with a transparent background.
 *
 * If rendering multiple RectangleView components which you wish to be scaled
 * relative to each other:
 *
 *  - Provide the largest size of the group as "maxSize"
 *  - Each rectangle should be provided its own "size" which will be compared to
 *    "maxSize", to determine the relative width of the rectangle from the largest
 *  - To control the actual width of the rendered rectangle, a max width can be provided
 *    (maxPixelWidth, defaults to 250)
 *
 */
export class RectangleView extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        size: PropTypes.number,
        maxSize: PropTypes.number,
        htmlUrl: PropTypes.string,
        maxPixelWidth: PropTypes.number,
        minPixelWidth: PropTypes.number,
    };

    static defaultProps = {
        size: 1,
        maxSize: 1,
        minPixelWidth: 3,
    };

    constructor(props) {
        super(props);
        const rectangleWidth = this.calculateRectangleWidth(
            props.size,
            props.maxSize,
            props.maxPixelWidth
        );
        this.state = {
            width: rectangleWidth,
        };
    }

    /*
     * If the size of the rectangle is going to change, set label opacity to 0
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextWidth = this.calculateRectangleWidth(
            nextProps.size,
            nextProps.maxSize,
            nextProps.maxPixelWidth
        );
        const currentWidth = this.calculateRectangleWidth(
            this.props.size,
            this.props.maxSize,
            this.props.maxPixelWidth
        );

        if (nextWidth !== currentWidth) {
            this.setState({width: nextWidth});
        }
    }

    render() {
        const rectangleContainer = (
            <div className='ui-funnel-section__rectangle__container'>
                <div
                    className='ui-funnel-section__rectangle__rectangle'
                    style={this.getRectangleStyle()}
                />
                <div
                    className='ui-funnel-section__rectangle__label-container'
                    style={this.getLabelContainerStyle()}
                >
                    {this.props.children}
                </div>
            </div>
        );

        return this.props.size > 0 && this.props.htmlUrl ? (
            <a
                href={this.props.htmlUrl}
                className='ui-funnel-section-tooltip-rectangle'
                data-title='Leads that flowed through this stage at some point during the specified date range'
            >
                {rectangleContainer}
            </a>
        ) : (
            rectangleContainer
        );
    }

    getRectangleStyle = () => {
        if (this.state.width === 0) {
            return {
                width: this.props.minPixelWidth,
                border: 0,
            };
        }

        return {width: this.state.width};
    };

    getLabelContainerStyle = () => {
        if (this.state.width === 0) {
            return {width: this.props.minPixelWidth};
        }

        return {width: this.state.width};
    };

    /**
     * Determine the proper width of the rectangle, based on props
     *
     * @param  {Object} size            size of the rectangle
     * @param  {Object} maxSize         max size of the rectangle
     * @param  {Object} maxPixelWidth   What number of px should the max size be
     * @return {number}                 rectangle width in px.
     */
    calculateRectangleWidth(size, maxSize, maxPixelWidth) {
        const percentOfMax = maxSize ? size / maxSize : 0; // Avoid div/0

        return percentOfMax * maxPixelWidth;
    }
}
